(() => {

    const row = () => {
        const dir = {
            restrict: 'A',
            replace: true,
            scope: {
                label: '@',
                subLabel: '@',
                hideLabel: '@',
                value: '=',
                total: '='
            },
            link: scope => {
                scope.$watch('value', newVal => {
                    scope.valueAsPercentage = '';

                    if (newVal !== undefined) {
                        if (newVal === '<5') {
                            scope.valueAsPercentage = 'N/P';
                        } else if (newVal === '0') {
                            scope.valueAsPercentage = '0%';
                        } else if (!isNaN(parseFloat(newVal)) && scope.total > 0) {
                            const numericValue = parseFloat(newVal);
                            let val = (numericValue / scope.total) * 100;
                            val = +(Math.round(val + 'e+2') + 'e-2'); // Round to two decimals
                            scope.valueAsPercentage = val + '%';
                        } else {
                            scope.valueAsPercentage = 'N/P'; // Handle invalid or unexpected cases
                        }
                    }
                });
            },
            template: `
            <tr>
                <td>
                    <strong ng-bind="label" ng-hide="hideLabel"></strong>
                    <div ng-if="subLabel" ng-bind="subLabel"></div>
                </td>
                <td ng-bind="value"></td>
                <td ng-bind="valueAsPercentage"></td>
            </tr>`
        };

        return dir;
    };

    angular.module('Uscapp').directive('atRow', row);

    const progress = () => {

        const link = scope => {
            scope.$watch('label', newVal => {
                if (newVal) {
                    scope.lessThan = scope.label[0] === '<' ? 'less-than' : '';
                }
            });
        }

        const dir = {
            restrict: 'E',
            replace: true,
            scope: {
                width: '@',
                loaded: '=',
                label: '='
            },
            link: link,
            template: '<div class="progress {{ lessThan }}"><div class="bar" ng-style="{ \'width\' : loaded ? width + \'%\' : \'30px\' }"> <span class="bar-label" ng-class="{\'faded\': loaded && width == 0}" ng-bind="label"></span></div></div>'
        };

        return dir;
    }

    angular.module('Uscapp').directive('atProgress', progress);

    const pie = () => {

        const template = `
            <div class="pie-wrapper">
                <div class="csspie" data-value="{{ value }}"></div>
            </div>
        `;

        const dir = {
            restrict: 'E',
            replace: true,
            scope: {
                value: '=',
                total: '='
            },
            template: template,
            link: scope => {
                scope.$watch('value',
                    newVal => {
                        scope.valueAsPercentage = undefined;
                        if (newVal !== undefined) {
                            scope.valueAsPercentage = scope.value !== 0 ? scope.value + '%' : '<1%';
                        }
                    });
            }
        };

        return dir;
    }

    angular.module('Uscapp').directive('atPie', pie);


    const counter = () => {

        const link = (scope, el, attrs) => {
            scope.naString = 'To preserve individual privacy, no data is reported in this category';

            scope.$watch('text', newVal => {
                if (newVal) {
                    scope.na = scope.text === 'NP';

                    delete scope.parsed;
                    delete scope.percentageInt;
                    delete scope.percentage;

                    if (attrs.hasOwnProperty('op')) {
                        scope.isOp = true;
                    }

                    if (!scope.isOp) {
                        const total = parseInt(scope.total, 10);
                        scope.parsed = parseInt(scope.text, 10);

                        if (!isNaN(scope.parsed) && !isNaN(total) && scope.parsed !== 0) {
                            scope.percentageInt = Math.round(scope.parsed / total * 100);
                            scope.percentage = scope.percentageInt === 0 ? '<1%' : scope.percentageInt + '%';
                        }
                    }
                }
            });
        }

        const template = `
            <div ng-class="{ 'faded' : na }" class="counter-wrapper" ng-hide="na">
                <div class="d-flex">
                    <div class="d-flex flex-column justify-content-center">
                        <at-pie ng-class="{'zero-pie' : parsed === 0}" value="percentageInt" ng-if="total"></at-pie>
                    </div>
                   <div class="text-wrapper">                                    
                        <p><span class="counter" ng-class="{ 'is-op' : isOp }" ng-if="!na" ng-bind="text"></span> {{ subtext }}</p>   
                    </div>                    
                </div>
            </div>
        `;

        const dir = {
            restrict: 'E',
            replace: true,
            scope: {
                text: '=',
                subtext: '@',
                wasWere: '=',
                total: '='
            },
            link: link,
            template: template
        };

        return dir;
    }

    angular.module('Uscapp').directive('atCounter', counter);



})();